import React from 'react';
import cn from 'classnames';
import styles from './Contacts.scss';

import { setPopUp } from 'actions/environment';
import { formatPhoneNumber } from 'utils';
import iconContact from 'assets/images/icons/icon-user.svg';
import iconLink from 'assets/images/icons/icon-link.svg';
import iconTelegram from 'assets/images/icons/telegram-icon.svg';
import iconWhatsapp from 'assets/images/icons/whatsapp-icon.svg';
import { useTranslation } from 'react-i18next';
import AppointmentButton from '../../../Appointment/AppointmentButton/AppointmentButton';
import { useDispatch } from 'react-redux';
import { gaEvent, trackGA } from '../../../../services/ga';
import { clickContact } from '../../../../actions/building';

const renderContactList = (official_site, link, list, t, print) => (
  <div className={cn(styles.List, { [styles.ContactsPrint]: print })}>
    <div className={styles.Header}>{t('components.building.main.contacts.contacts')}</div>
    <div className={styles.InnerWrap}>
      {list}
      {official_site ? (
        <a href={link} className={cn(styles.SiteLink, styles.OnlyMobile)} target="_blank">
          {t('components.building.main.contacts.site')}
          <img src={iconLink} alt="" />
        </a>
      ) : (
        ''
      )}
    </div>
  </div>
);

const Contacts = ({ className, building, print, objectType, profile }) => {
  const { official_site, availability_record, sales_offices, title, id } = building.data;
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const hasValidContacts =
    Array.isArray(sales_offices) &&
    sales_offices.length > 0 &&
    sales_offices.some(
      (office) =>
        Array.isArray(office.users) &&
        office.users.some((user) => user.phone || user.telegram || user.whatsapp)
    );

  const handleTrackEvent = ({ eventLabel }) => {
    trackGA(
      gaEvent.contactsDialogButtonsClick({
        eventLabel,
        eventContent: title,
        productType: objectType,
        productName: title,
        productID: id,
        user_id: profile.id,
      })
    );
  };

  const list = sales_offices.flatMap((office, index) =>
    office.users.map((user, userIndex) => (
      <div className={styles.Inner} key={`${index}-${userIndex}`}>
        <div className={styles.Top}>
          <div className={styles.Avatar}>
            <img alt="contact-men" src={iconContact} className={styles.IconContact} />
          </div>
          <div className={styles.Column}>
            <div className={styles.Name}>
              {user.first_name} {user.last_name || ''}
            </div>
            <div className={styles.Label}>{user.position}</div>
          </div>
        </div>
        <div className={styles.ContactGroup}>
          {user.phone && (
            <a
              href={`tel:${user.phone.replace(/-|\s/g, '')}`}
              className={styles.Phone}
              onClick={() => handleTrackEvent({ eventLabel: 'telefon' })}
            >
              {formatPhoneNumber(user.phone)}
            </a>
          )}
          <div className={styles.IconGroup}>
            {!print && user.telegram && (
              <a
                href={user.telegram}
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => handleTrackEvent({ eventLabel: 'telegram' })}
              >
                <img alt="telegram-icon" src={iconTelegram} className={styles.ContactIcon} />
              </a>
            )}
            {!print && user.whatsapp && (
              <a
                href={user.whatsapp}
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => handleTrackEvent({ eventLabel: 'whatsapp' })}
              >
                <img alt="whatsapp-icon" src={iconWhatsapp} className={styles.ContactIcon} />
              </a>
            )}
          </div>
        </div>
        {user.email && (
          <div className={styles.Item}>
            <a href={`mailto:${user.email}`} className={styles.Mail}>
              {user.email}
            </a>
          </div>
        )}
      </div>
    ))
  );

  const link = `http://${official_site.replace(/http(s)?:\/\//, '')}`;

  const handleShowContacts = () => {
    trackGA(
      gaEvent.buildingRightMenuButtonsClick({
        eventLabel: 'pokazat_kontakty',
        eventContent: title,
        productType: objectType,
        productName: title,
        productID: id,
        user_id: profile.id,
      })
    );

    dispatch(clickContact({ objectId: id, userId: Number(profile.id) }));

    dispatch(
      setPopUp(renderContactList(official_site, link, list, t, false), {
        closeStyleName: 'Default',
        contentStyleName: 'Default',
        closeIcon: 'default',
        lockScroll: false,
      })
    );
  };

  if (print) {
    return renderContactList(official_site, link, list, t, true);
  }

  return (
    <div className={cn(styles.Contacts, className, { [styles.ContactsPrint]: print })}>
      <h3 className={styles.Title}>
        {t('components.building.main.contacts.contacts')}
        {official_site ? (
          <a href={link} className={cn(styles.SiteLink, styles.NotMobile)} target="_blank">
            {t('components.building.main.contacts.site')}
            <img src={iconLink} alt="" />
          </a>
        ) : (
          ''
        )}
      </h3>
      <div className={styles.Subtitle}>Застройщика и отдела продаж</div>
      <div className={styles.ButtonsGroup}>
        {hasValidContacts && (
          <button
            className={cn('button-primary', styles.ShowContactsButton)}
            onClick={handleShowContacts}
          >
            {t('components.building.main.contacts.showContacts')}
          </button>
        )}
        {availability_record && (
          <AppointmentButton
            buildingId={building.data.id}
            profile={profile}
            title={title}
            objectType={objectType}
          />
        )}
        {!hasValidContacts && !availability_record && (
          <div className={styles.NotFound}>
            <div className={styles.NotFoundText}>
              {t('components.building.main.contacts.empty')}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Contacts;



// WEBPACK FOOTER //
// ./src/components/Building/Main/Contacts/Contacts.js